import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewBaron = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M19.9 8.692 15.845 22l-.592-1.934a9.732 9.732 0 0 0-6.506 0L8.155 22 4.1 8.692a2.318 2.318 0 0 1-.014-1.3c.12-.427.36-.816.694-1.126L9.339 2l-1.99 5.338L12 6.217l4.648 1.121L14.662 2l4.557 4.266.68 2.426Zm-9.504 4.422c0-.62-.55-1.123-1.227-1.123-.678 0-1.227.503-1.227 1.123s.549 1.123 1.227 1.123l1.227-1.123Zm2.837 1.832c0-.617-.55-1.118-1.227-1.118s-1.226.5-1.226 1.118c0 .617.549 1.118 1.226 1.118l1.227-1.118Zm0-3.672c0-.62-.55-1.123-1.227-1.123s-1.226.502-1.226 1.123c0 .62.549 1.123 1.226 1.123l1.227-1.123Zm2.738 1.838c0-.62-.548-1.123-1.226-1.123-.678 0-1.227.503-1.227 1.123s.55 1.123 1.226 1.123l1.227-1.123Z"
    />
  </svg>
);
